import React from 'react'
import {
  BUILDING_LIST,
  CONFERENCE_ROOM,
  DASHBOARD,
  FLOOR_PLAN,
  LOGON_CONTAINER,
  MEETING_SPACES_SEQUENCE,
  MEETING_SPACE,
  MOVE_SEQUENCE,
  SERVICE_SEQUENCE,
  WORKSPACE,
  WORKSPACE_SHOW,
  WORKSPACELIST,
  SERVICE_REQUEST_DETAIL
} from './constants/const'
import ConferenceRoom from './pages/ConferenceRoom/ConferenceRoom'
import Dashboard from './containers/Dashboard/Dashboard'
import MeetingBooking from './pages/MeetingBooking/MeetingBooking'
import Workspace from './containers/Workspace/Workspace'
import WorkspaceList from './containers/Workspace/WorkspaceList/WorkspaceList'
import Logon from './pages/Logon/Logon'
import KioskContainer from './pages/Kiosk/Kiosk'
import ServiceRequest from './pages/ServiceRequest/ServiceRequest'
import EquipmentQR from './pages/EquipmentQR/EquipmentQR'
import RoomQR from './pages/RoomQR/RoomQR'
import WorkspaceBooking from './pages/WorkspaceBooking/WorkspaceBooking'
import WorkspacesEdit from './containers/Dashboard/Workspace/WorkspacesEdit'
import BuildingListPage from './pages/BuildingListPage/BuildingListPage'
import MoveSequence from './components/kiosk/KioskContent/MoveSequence/MoveSequence'
import MeetingSpacesSequence from './pages/MeetingSpacesSequence'
import MeetingSpaceShowMeeting from './containers/MeetingReservation/MeetingSpaceShowMeeting'
import MeetingList from './pages/MeetingList/MeetingList'
import {useUserState} from './context/UserContext'
import {useUIState} from './context/UIContext'
import {WorkspaceProvider} from './context/WorkspaceContext'
import WorkspaceMoreList from './pages/WorkspaceMoreList/WorkspaceMoreList'
import {MeetingProvider} from './context/MeetingContext'
import ServiceRequestList from './pages/ServiceRequestList/ServiceRequestList'
import RegisterKiosk from './containers/Kiosk/RegisterKiosk'
import ServiceCatalog from './pages/ServiceCatalog/ServiceCatalog'
import Move from './pages/Move/Move'
import styled from 'styled-components'
import Spinner from './components/Spinner/Spinner'
import * as ReactGA from 'react-ga'
import ServiceRequestDetail from './containers/Dashboard/ServiceRequests/Detail/ServiceRequestDetail'

const LoadView = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: #13294b;
  display: flex;
  justify-content: center;
  align-items: center;
`

const sendPageView = content => {
  if (content === MEETING_SPACE) {
    ReactGA.event({
      category: 'Page View',
      action: 'Meeting Booking'
    })
  }

  if (content === 'WORKSPACE_BOOKING') {
    ReactGA.event({
      category: 'Page View',
      action: 'Workspace Booking'
    })
  }

  if (content === SERVICE_SEQUENCE) {
    ReactGA.event({
      category: 'Page View',
      action: 'Service Request'
    })
  }

  if (content === MOVE_SEQUENCE) {
    ReactGA.event({
      category: 'Page View',
      action: 'Move Request'
    })
  }

  if (content === DASHBOARD) {
    ReactGA.event({
      category: 'Page View',
      action: 'Dashboard'
    })
  }

  if (content === 'SERVICE_CATALOG') {
    ReactGA.event({
      category: 'Page View',
      action: 'Service Catalog'
    })
  }
}

const AppRouter = () => {
  const {user} = useUserState()
  const uiState = useUIState()
  const {content, parentPage, contentProps} = uiState

  const getContentToRender = () => {
    let component
    switch (content) {
      case DASHBOARD:
        component = <Dashboard />
        break

      // TODO: Should the two meeting views use the same provider?
      case MEETING_SPACE:
        component = (
          <MeetingProvider>
            <MeetingBooking parentPage={parentPage} />
          </MeetingProvider>
        )
        break

      case MEETING_SPACES_SEQUENCE:
        component = (
          <MeetingProvider>
            <MeetingSpacesSequence
              room={contentProps.room}
              parentPage={parentPage}
            />
          </MeetingProvider>
        )
        break

      case CONFERENCE_ROOM:
        component = <ConferenceRoom />
        break

      case WORKSPACE:
        component = (
          <WorkspaceProvider>
            <Workspace parentPage={parentPage} />
          </WorkspaceProvider>
        )
        break
      case WORKSPACELIST:
        component = <WorkspaceList />
        break

      case LOGON_CONTAINER:
        component = <Logon />
        break
      case 'KIOSK_CONTAINER':
        component = <KioskContainer parentPage={parentPage} />
        break
      case SERVICE_SEQUENCE:
        component = (
          <ServiceRequest
            parentPage={parentPage}
            user={user}
            activityType={contentProps.activityType}
            probType={contentProps.probType}
            initialForm={contentProps.initialForm}
            catalogHeader={contentProps.catalogHeader}
            hideFields={contentProps.hideFields}
            instructions={contentProps.instructions}
          />
        )
        break

      case 'EQUIPMENT_QR':
        component = (
          <EquipmentQR
            parentPage={parentPage}
            isEquipmentQR
            eqId={contentProps.eqId}
          />
        )
        break

      case 'ROOM_QR':
        component = (
          <WorkspaceProvider>
            <RoomQR parentPage={parentPage} isRoomQR />
          </WorkspaceProvider>
        )
        break
      case 'WORKSPACE_BOOKING':
        component = (
          <WorkspaceProvider>
            <WorkspaceBooking
              roomCode={contentProps.roomCode}
              parentPage={parentPage}
              isQrView={contentProps.isQrView}
            />
          </WorkspaceProvider>
        )
        break

      case WORKSPACE_SHOW:
        component = (
          <WorkspacesEdit
            reservation={contentProps.reservation}
            onCancel={contentProps.onCancel}
            onCancelReservation={contentProps.onCancelReservation}
          />
        )
        break

      case FLOOR_PLAN:
        component = <KioskContainer />
        break

      case BUILDING_LIST:
        component = <BuildingListPage />
        break
      case MOVE_SEQUENCE:
        component = (
          <MoveSequence
            type={contentProps.type}
            user={contentProps.user}
            employee={contentProps.employee}
          />
        )
        break

      case 'MOVE':
        component = <Move parentPage={parentPage} />
        break

      case 'MEETING_SPACES_SHOW':
        component = (
          <MeetingSpaceShowMeeting
            room={contentProps.room}
            parentPage={parentPage}
          />
        )
        break

      case 'MEETINGS_MORE_LIST':
        component = <MeetingList parentPage={parentPage} />
        break

      case 'WORKSPACE_MORE_LIST':
        component = <WorkspaceMoreList parantPage={parentPage} />
        break

      case 'SERVICE_MORE_LIST':
        component = <ServiceRequestList parentPage={parentPage} />
        break

      case SERVICE_REQUEST_DETAIL:
        component = (
          <ServiceRequestDetail
            activityLogId={contentProps.activityLogId}
            parentPage={parentPage}
          />
        )
        break

      case 'REGISTER_KIOSK':
        component = <RegisterKiosk />
        break

      case 'SERVICE_CATALOG':
        component = <ServiceCatalog parentPage={parentPage} />
        break
      default:
        return (
          <LoadView>
            <Spinner />
          </LoadView>
        )
    }

    sendPageView(content)
    return component
  }

  return getContentToRender()
}

export default AppRouter
